import React from "react";
import { Box, Typography, Grid, Divider, Alert } from "@mui/material";
import AppModal from "../common/AppModal";
import StatusChip from "../common/StatusChip";
import DetailItem from "../common/DetailItem";
import AppCircularProgress from "../common/AppCircularProgress";
import { BranchResponseDto } from "../../shared/dtos/branch/BranchResponseDto";

interface ViewBranchModalProps {
  open: boolean;
  onClose: () => void;
  branch: BranchResponseDto | null;
  loading: boolean;
  error: string | null;
}

const ViewBranchModal: React.FC<ViewBranchModalProps> = ({
  open,
  onClose,
  branch,
  loading,
  error,
}) => {
  const renderContent = (): React.ReactNode => {
    if (loading) return <AppCircularProgress />;
    if (error) return <Alert severity="error">{error}</Alert>;
    if (!branch) return <Typography>No branch data available.</Typography>;

    const { address } = branch;
    const fullAddress = address
      ? `${address.streetLine1}, ${address.city}, ${address.country}`
      : "N/A";

    return (
      <Box>
        <Grid container spacing={2}>
          <DetailItem label="Branch Name" value={branch.name} />
          <DetailItem label="Branch Code" value={branch.branchCode} />
          <Grid {...({ item: true, xs: 12, sm: 6 } as Record<string, unknown>)}>
            <Typography variant="body2" color="text.secondary">
              Status
            </Typography>
            <StatusChip status={branch.status} />
          </Grid>
          <DetailItem label="Contact Phone" value={branch.contactPhone} />
          <DetailItem label="Contact Email" value={branch.contactEmail} />
        </Grid>
        <Divider sx={{ my: 2 }}>
          <Typography variant="overline">Address</Typography>
        </Divider>
        <Typography sx={{ fontSize: "0.9rem" }}>{fullAddress}</Typography>
      </Box>
    );
  };

  return (
    <AppModal open={open} onClose={onClose} title="Branch Details" width="md">
      {renderContent()}
    </AppModal>
  );
};

export default ViewBranchModal;
